import { generateTableUnOrderedList, sectionStyle } from "../screens/JaldiLab/Chapters/ChapterList";

export let table1 = [
    {
        section_no: "S. 9.",
        title: "Exhibiting or Showing Documents to Witness or Accused at a Remote Point",
        details: <><span style={sectionStyle}>9.1</span> If the document is at the Court Point, by transmitting a copy or image of the document to the Remote Point electronically, including through a document visualizer;</>,
        consideration: <>{generateTableUnOrderedList(["Document visualizers must be provided and adequate space must be provided for its storage when not in use. "])}</>
    },

];

export let table2 = [
    {
        section_no: "S. 5.",
        title: "Preparatory Arrangements",
        details: <>
            <p><span style={sectionStyle}>5.6.</span> The Coordinator at the Remote Point shall ensure that:</p>
            <p><span style={sectionStyle}>5.6.3</span> No unauthorised person enters the video conference room when the video conference is in progress. </p>
            <p><span style={sectionStyle}>5.6.4</span> The person being examined is not prompted, tutored, coaxed, induced or coerced in any manner by any person and that the person being examined does not refer to any document, script or device without the permission of the concerned Court during the course of examination. </p>

        </>,
        consideration: <>
            {generateTableUnOrderedList(["Adequate security must be provided to ensure that unauthorised persons do not enter to disturb or influence the proceedings while video conferencing is taking place.",
            ])}
        </>
    },
    {
        section_no: "",
        title: "",
        details: <>
            <p>
                <span style={sectionStyle}>5.8</span> Before the scheduled video conferencing date, the Coordinator at the Court Point shall ensure that the Coordinator at the Remote Point receives certified copies, printouts or a soft copy of the non-editable scanned copies of all or any part of the record of proceedings which may be required for recording statements or evidence, or for reference. However, these shall be permitted to be used by the Required Person only with the permission of the Court.
            </p>
        </>,
        consideration: <>
            {generateTableUnOrderedList([
                "The room must be equipped with adequate computers, printout systems, scanners and other necessary technological provisions."
            ])}
        </>
    },
    {
        section_no: "",
        title: "",
        details: <>

            <p>
                <span style={sectionStyle}>5.9</span> Whenever required the Court shall order the Coordinator at the Remote Point or at the Court Point to provide -
            </p>
            <p>
                <span style={sectionStyle}>5.9.1</span> A translator in case the person to be examined is not conversant with the official language of the Court.
            </p>
            <p>
                <span style={sectionStyle}>5.9.2</span> An expert in sign languages in case the person to be examined is impaired in speech and/or hearing.
            </p>
            <p>
                <span style={sectionStyle}>5.9.3</span> An interpreter or a special educator, as the case may be, in case a person to be examined is differently abled, either temporarily or permanently.
            </p>

        </>,
        consideration: <>
            {generateTableUnOrderedList(["Adequate space must be designated for all support persons including translators, sign language experts, interpreters, special educators, etc."
            ])}
        </>
    },
];